/* ALCO · Carrito sin salir de la página (16-oct-2026, tema «Respaldo de FABLE»).
   1) Botón «Agregar» de la tarjeta (snippets/alco-tarjeta-catalogo.liquid, forma [data-acx-cmp]) que, al agregar,
      se vuelve «− n +» con la cantidad REAL del carrito para esa variante. Agrega con /cart/add.js y cambia con
      /cart/change.js (por la línea de esa variante), SIN abrir el cajón; respeta el mínimo y el paso de la tarjeta
      (formato de venta / reglas de cantidad). Llegar a 0 la regresa a «Agregar».
   2) Barra flotante de envío gratis (snippets/alco-barra-flotante.liquid, [data-alco-bf]): «Te faltan $X para envío
      gratis» + avance, y «Ver carrito · $total», que abre el cajón del tema (si no hay cajón, va a /cart).
   Se mantiene al día cuando el carrito cambia por otro lado:
   - PUB_SUB_EVENTS.cartUpdate del tema (cajón, página del producto, etc.);
   - cualquier repintado del cajón con renderContents (p. ej. «Agregar todo» de la Lista de resurtidos);
   - el evento propio «alco:carrito» (document) que esto mismo dispara con { cart, origen };
   - al volver a la pestaña (visibilitychange, focus, pageshow del bfcache) se relee /cart.js (18-oct).
   «+» y «−» calculan SIEMPRE sobre el /cart.js leído justo antes (no sobre lo guardado), y tras un error (p. ej. 422
   por existencia, que puede agregar lo disponible) se relee y se repinta todo como cambio propio (18-oct).
   El dinero sale con el formato de la tienda (shop.money_format, en #alco-carrito-cfg); la meta también viene de ahí
   (ajuste del tema «ALCO · Envío gratis»). Lo carga layout/theme.liquid sólo con alguno de los dos ajustes prendido. */
(function () {
  if (window.alcoCarrito) return;

  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('alco-carrito-cfg') || {}).textContent || '{}') || {}; } catch (e) { cfg = {}; }
  var R = window.routes || {};
  var URL_ADD = (cfg.addUrl || R.cart_add_url || '/cart/add') + '.js';
  var URL_CHANGE = (cfg.changeUrl || R.cart_change_url || '/cart/change') + '.js';
  var URL_CART = cfg.cartUrl || R.cart_url || '/cart';
  var META = (cfg.meta !== undefined && cfg.meta !== null && isFinite(Number(cfg.meta))) ? Number(cfg.meta) : null;
  var FORMATO = (function (f) {
    if (!f) return null;
    var t = document.createElement('textarea'); t.innerHTML = String(f); return t.value;
  })(cfg.formato);

  /* ---------- Dinero con el formato de la tienda ---------- */
  function conFormato(cent, formato) {
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(formato);
    function num(n, dec, miles, punto) {
      miles = miles === undefined ? ',' : miles; punto = punto === undefined ? '.' : punto;
      var s = (n / 100).toFixed(dec).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + miles) + (s[1] ? punto + s[1] : '');
    }
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = num(cent, 0); break;
      case 'amount_with_comma_separator': v = num(cent, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(cent, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = num(cent, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = num(cent, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = num(cent, 0, ' ', ''); break;
      default: v = num(cent, 2);
    }
    return m ? formato.replace(m[0], v) : v;
  }
  function dinero(cent) {
    cent = Math.round(Number(cent) || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cent, FORMATO || undefined); } catch (e) { /* sigue */ }
    }
    return conFormato(cent, FORMATO || '{{amount}}');
  }

  /* ---------- Estado del carrito ---------- */
  var estado = null; // último carrito completo conocido (/cart.js o respuesta de /cart/change.js)
  function lineas(vid) {
    if (!estado || !estado.items) return [];
    return estado.items.filter(function (it) { return String(it.variant_id) === String(vid); });
  }
  function cuantas(vid) { return lineas(vid).reduce(function (a, it) { return a + (Number(it.quantity) || 0); }, 0); }
  function centavos(vid) { return lineas(vid).reduce(function (a, it) { return a + (Number(it.final_line_price !== undefined ? it.final_line_price : it.line_price) || 0); }, 0); }

  function leeCarrito() {
    return fetch(URL_CART + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function firma(c) {
    if (!c || !c.items) return '';
    return c.item_count + '|' + c.total_price + '|' + c.items.map(function (it) { return it.key + ':' + it.quantity; }).join(',');
  }

  /* Orden de las respuestas (18-oct): una lectura de /cart.js que se cruzó con un cambio propio o con otro carrito ya
     aplicado se descarta (puede traer el carrito de ANTES). «gen» sube con cada carrito aplicado y con cada cambio que
     empieza o termina; «enVuelo» cuenta los cambios propios en curso. Si dos cambios se cruzan, o llega un carrito del
     tema a la mitad, al terminar el último se relee (sucio). */
  var gen = 0, enVuelo = 0, sucio = false;
  function empieza() { if (enVuelo > 0) sucio = true; enVuelo++; gen++; }
  function termina() {
    enVuelo = Math.max(0, enVuelo - 1); gen++;
    if (!enVuelo && sucio) { sucio = false; programa('sucio'); }
  }

  var tRefresco = null, motivoPend = '';
  var PRIORIDAD = { tema: 0, sucio: 1, vuelta: 2 };
  // motivo 'vuelta': la pestaña volvió a verse (o salió del bfcache); el carrito pudo cambiar en otra pestaña, así que si
  // cambió se repintan también el cajón y la burbuja (lo demás del tema ya se repintó solo cuando el cambio vino de aquí).
  // motivo 'sucio' (18-oct, revisor): se cruzaron cambios propios; la burbuja y el cajón pudieron quedar con el HTML de la
  // respuesta más vieja, así que también se traen de nuevo (el cajón abierto sólo si el carrito cambió).
  function programa(motivo) {
    motivo = motivo || 'tema';
    if (!motivoPend || PRIORIDAD[motivo] > PRIORIDAD[motivoPend]) motivoPend = motivo;
    clearTimeout(tRefresco);
    tRefresco = setTimeout(function () { var m = motivoPend; motivoPend = ''; refresca(m); }, 180);
  }
  function refresca(motivo) {
    if (enVuelo) { sucio = true; return; }
    var g = gen, antes = firma(estado);
    var conSec = motivo === 'vuelta' || motivo === 'sucio';
    var pSec = conSec ? traeSecciones().catch(function () { return null; }) : null;
    leeCarrito().then(function (c) {
      if (enVuelo || g !== gen) { if (enVuelo) sucio = true; return; }
      var cambio = firma(c) !== antes;
      if (motivo === 'sucio' || (motivo === 'vuelta' && cambio)) {
        return pSec.then(function (sec) {
          if (enVuelo || g !== gen) { if (enVuelo) sucio = true; return; }
          var cd = document.querySelector('cart-drawer');
          var abierto = cd && cd.classList.contains('active');
          // Sin cambio y con el cajón abierto no se reemplaza su HTML (se perdería el foco); la burbuja sí.
          if (sec && !cambio && abierto) delete sec['cart-drawer'];
          pintaSecciones(sec);
          aplicar(c, motivo, null, true);
        });
      }
      aplicar(c, motivo === 'vuelta' ? 'vuelta' : 'tema');
    }).catch(function () { /* se queda lo último */ });
  }

  // avisa = true: el cambio lo hizo esta página (o se descubrió aquí): se ajusta el cajón vacío/lleno y se publica
  // cartUpdate para el resto del tema. Los cambios que avisa el propio tema no se vuelven a publicar.
  function aplicar(cart, origen, vid, avisa) {
    if (!cart || !Array.isArray(cart.items)) return;
    if (avisa === undefined) avisa = origen === 'alco-carrito';
    estado = cart;
    gen++;
    if (avisa) {
      var cd = document.querySelector('cart-drawer');
      if (cd) cd.classList.toggle('is-empty', !cart.item_count);
    }
    document.querySelectorAll('[data-acx-cmp]').forEach(function (f) { pintaForm(f); });
    pintaBarra();
    try { document.dispatchEvent(new CustomEvent('alco:carrito', { detail: { cart: cart, origen: origen } })); } catch (e) { /* navegador viejo */ }
    if (avisa) {
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'alco-carrito', cartData: cart, productVariantId: vid ? String(vid) : undefined });
        }
      } catch (e) { /* sin pubsub */ }
    }
  }

  /* ---------- Secciones del tema (cajón y burbuja del ícono), SIN abrir el cajón ---------- */
  function secciones() {
    var s = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) s.unshift('cart-drawer');
    return s;
  }
  function html(t) { return new DOMParser().parseFromString(t, 'text/html'); }
  // Section Rendering API: el cajón y la burbuja tal como están en el servidor (tras un error o un cambio de otra pestaña).
  // SIN «Accept: application/json»: con ese encabezado /collections/x?sections=… contesta el JSON de la colección.
  function traeSecciones() {
    return fetch(window.location.pathname + '?sections=' + secciones().join(','), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function pintaSecciones(sec) {
    if (!sec) return;
    var cd = document.querySelector('cart-drawer');
    if (cd && sec['cart-drawer']) {
      var nuevo = html(sec['cart-drawer']).querySelector('#CartDrawer');
      var viejo = document.getElementById('CartDrawer');
      if (nuevo && viejo) {
        viejo.innerHTML = nuevo.innerHTML;
        var ov = cd.querySelector('#CartDrawer-Overlay');
        if (ov && typeof cd.close === 'function') ov.addEventListener('click', cd.close.bind(cd));
      }
    }
    if (sec['cart-icon-bubble']) {
      var b = document.getElementById('cart-icon-bubble');
      var s = html(sec['cart-icon-bubble']).querySelector('.shopify-section');
      if (b && s) b.innerHTML = s.innerHTML;
    }
  }

  function post(url, cuerpo) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status || j.errors) {
          var txt = j.description || j.message || (typeof j.errors === 'string' ? j.errors : '') || '';
          var e = new Error(txt || 'No se pudo actualizar el carrito.');
          e.deShopify = !!txt;
          throw e;
        }
        return j;
      });
    });
  }

  /* ---------- Tarjeta: «Agregar» ↔ «− n +» ---------- */
  function datos(f) {
    var qmin = Math.max(1, Math.round(Number(f.dataset.qmin) || 1));
    var qinc = Math.max(1, Math.round(Number(f.dataset.qinc) || 1));
    var qmax = f.dataset.qmax ? Number(f.dataset.qmax) : Infinity;
    return { vid: f.dataset.variant, qmin: qmin, qinc: qinc, qmax: qmax };
  }
  function formasDe(vid) { return document.querySelectorAll('[data-acx-cmp][data-variant="' + String(vid).replace(/[^0-9]/g, '') + '"]'); }

  function pintaForm(f) {
    if (!estado) return;
    var d = datos(f);
    var n = cuantas(d.vid);
    // Aviso rojo viejo (18-oct, revisor): si la cantidad ya no es la de cuando se mostró, se quita.
    var p = f.querySelector('[data-cmp-err]');
    if (p && !p.hidden && p.dataset.q !== undefined && p.dataset.q !== String(n)) { p.textContent = ''; p.hidden = true; delete p.dataset.q; }
    // Con pasos en cola (toques rápidos) se sigue mostrando la cantidad a la que se va.
    if (ocupados[d.vid]) {
      var v = vuelo[d.vid];
      if (pendientes[d.vid]) { ponN(f, pendientes[d.vid].meta, null); return; }
      if (v && !v.agregar && v.esperado !== undefined) { ponN(f, v.esperado, null); return; }
    }
    ponN(f, n, centavos(d.vid));
  }
  // El foco no se pierde cuando el botón que lo tenía se esconde o se deshabilita (18-oct: también «+» al llegar al tope).
  function cuidaFoco(f, foco, n) {
    if (!foco) return;
    var add = f.querySelector('[data-cmp-add]'), st = f.querySelector('[data-cmp-step]');
    var mas = f.querySelector('[data-cmp-q="1"]'), menos = f.querySelector('[data-cmp-q="-1"]');
    if (n > 0 && foco === add && mas) (mas.disabled ? menos : mas).focus();
    else if (n > 0 && foco === mas && mas.disabled && menos) menos.focus();
    else if (n <= 0 && st && st.contains(foco) && add) add.focus();
  }
  function ponN(f, n, cent) {
    var d = datos(f);
    var add = f.querySelector('[data-cmp-add]'), st = f.querySelector('[data-cmp-step]');
    var nn = f.querySelector('[data-cmp-n]'), mas = f.querySelector('[data-cmp-q="1"]');
    var foco = document.activeElement && f.contains(document.activeElement) ? document.activeElement : null;
    // Cantidad provisional (cent null, toques en cola): aunque llegue a 0 se deja «− 0 +» hasta que se confirme, para que
    // los toques rápidos en «−» no caigan en «Agregar» (que aparecería bajo el dedo) y vuelvan a agregar.
    var conPasos = n > 0 || (cent === null && st && !st.hidden);
    var eraPasos = st && !st.hidden;
    f.dataset.en = n;
    f.classList.toggle('is-en', n > 0);
    if (add) add.hidden = conPasos;
    if (st) st.hidden = !conPasos;
    // Al volverse «Agregar» se ignora un instante: el último toque rápido en «−»/«+» no debe agregar.
    if (eraPasos && !conPasos) f.dataset.recienAgregar = String(Date.now() + 600);
    if (nn && nn.textContent !== String(n)) nn.textContent = n;
    if (mas) mas.disabled = n + d.qinc > d.qmax;
    cuidaFoco(f, foco, conPasos ? Math.max(n, 1) : 0);
    // «Total (n) pz»: con lo que hay en el carrito; sin nada, el mínimo × precio (como lo pinta Liquid).
    var card = f.closest('.acx');
    var li = card && card.querySelector('[data-cmp-total]');
    if (li && cent !== null) { // cent null: cantidad provisional (toques en cola), el total se pinta al confirmar
      var sn = li.querySelector('[data-n]'), st2 = li.querySelector('[data-total]');
      var q = n > 0 ? n : Number(li.dataset.baseN) || d.qmin;
      var c = n > 0 ? cent : Number(li.dataset.baseCent) || 0;
      if (sn) sn.textContent = q;
      if (st2) st2.textContent = dinero(c) + ' mxn';
    }
  }
  // El aviso guarda la cantidad que había al mostrarse (data-q); si el carrito cambia después, pintaForm lo quita.
  function error(f, txt) {
    var vid = f.dataset.variant;
    formasDe(vid).forEach(function (g) {
      var p = g.querySelector('[data-cmp-err]');
      if (!p) return;
      if (g === f && txt) { p.textContent = txt; p.hidden = false; p.dataset.q = String(estado ? cuantas(vid) : 0); }
      else { p.textContent = ''; p.hidden = true; delete p.dataset.q; }
    });
  }
  var ocupados = {};
  function ocupado(vid, si) {
    if (si) ocupados[vid] = true; else delete ocupados[vid];
    formasDe(vid).forEach(function (g) {
      g.classList.toggle('is-cargando', !!si);
      g.setAttribute('aria-busy', si ? 'true' : 'false');
    });
  }

  function agregar(vid, q) {
    return post(URL_ADD, { items: [{ id: Number(vid), quantity: q }], sections: secciones(), sections_url: window.location.pathname })
      .then(function (res) { pintaSecciones(res.sections); return leeCarrito(); });
  }
  // «fresco» es el carrito que se acaba de leer de /cart.js (no el guardado en memoria).
  function cambiar(vid, nueva, fresco) {
    var ls = (fresco.items || []).filter(function (it) { return String(it.variant_id) === String(vid); });
    if (!ls.length) return nueva > 0 ? agregar(vid, nueva) : Promise.resolve(fresco);
    // Si la variante está en varias líneas (p. ej. con propiedades), se ajusta la última.
    var l = ls[ls.length - 1];
    var total = ls.reduce(function (a, it) { return a + (Number(it.quantity) || 0); }, 0);
    var otras = total - (Number(l.quantity) || 0);
    return post(URL_CHANGE, { id: l.key, quantity: Math.max(0, nueva - otras), sections: secciones(), sections_url: window.location.pathname })
      .then(function (cart) { pintaSecciones(cart.sections); delete cart.sections; return cart; });
  }
  function cuantasEn(c, vid) {
    return ((c && c.items) || []).reduce(function (a, it) { return a + (String(it.variant_id) === String(vid) ? Number(it.quantity) || 0 : 0); }, 0);
  }

  /* Toques rápidos (18-oct, revisor): mientras una variante está ocupada, los toques en «+» / «−» ya no se tiran.
     Se lleva la cantidad a la que se quiere llegar («meta»), se muestra en la tarjeta y, al terminar el viaje en curso,
     se manda en UNA sola petición (cantidad absoluta, corregida si el carrito cambió por fuera mientras tanto).
     - vuelo[vid]: { esperado, agregar } del cambio en curso (esperado = cantidad que se muestra mientras viaja).
     - pendientes[vid]: { meta, f } de los toques que llegaron durante el viaje.
     Un doble clic en «Agregar» sigue agregando una sola vez (sólo se encolan toques sobre «− n +»). */
  var vuelo = {}, pendientes = {};
  // Siguiente cantidad a partir de n con un paso (+1 / −1); null si «+» pasaría el tope.
  function siguiente(n, paso, d) {
    var x;
    if (paso > 0) { x = n < d.qmin ? d.qmin : n + d.qinc; return x > d.qmax ? null : x; }
    x = n - d.qinc; return x < d.qmin ? 0 : x;
  }
  // Ajusta una cantidad absoluta a las reglas de la tarjeta (mínimo y tope).
  function normaliza(x, d) {
    if (x <= 0) return 0;
    if (x < d.qmin) x = d.qmin;
    if (x > d.qmax) x -= Math.ceil((x - d.qmax) / d.qinc) * d.qinc;
    return x < d.qmin ? 0 : x;
  }
  function ponMeta(vid, m) { formasDe(vid).forEach(function (g) { ponN(g, m, null); }); }

  function accion(f, paso) {
    var d = datos(f);
    if (ocupados[d.vid]) {
      var v = vuelo[d.vid] || {};
      var p = pendientes[d.vid];
      if (!p && (paso > 0 && v.agregar)) return; // doble clic en «Agregar»
      var desde = p ? p.meta : (v.esperado !== undefined ? v.esperado : cuantas(d.vid));
      var m = siguiente(desde, paso, d);
      if (m === null) return;
      pendientes[d.vid] = { meta: m, f: f };
      ponMeta(d.vid, m);
      return;
    }
    var n0 = estado ? cuantas(d.vid) : Number(f.dataset.en) || 0;
    ejecuta(f, function (n) { return siguiente(n, paso, d); }, n0 === 0 && paso > 0);
  }

  // calc(n) da la cantidad nueva a partir de la cantidad real n (o null si no hay nada que mandar).
  function ejecuta(f, calc, esAgregar) {
    var d = datos(f);
    error(f, '');
    ocupado(d.vid, true);
    empieza();
    var nueva = 0, n = 0;
    var n0 = estado ? cuantas(d.vid) : Number(f.dataset.en) || 0;
    var esp = calc(n0);
    vuelo[d.vid] = { agregar: !!esAgregar };
    // Mientras viaja se muestra la cantidad esperada («Agregar» conserva su ruedita).
    if (!esAgregar && esp !== null && esp !== n0) { vuelo[d.vid].esperado = esp; ponMeta(d.vid, esp); }
    else if (esp !== null) vuelo[d.vid].esperado = esp;
    function fin(sigue) {
      var p = pendientes[d.vid];
      delete pendientes[d.vid];
      delete vuelo[d.vid];
      ocupado(d.vid, false);
      termina();
      var base = estado ? cuantas(d.vid) : 0;
      if (sigue && p && normaliza(p.meta, d) !== base) {
        // Lo que el cliente pidió con los toques, corregido por lo que haya cambiado por fuera desde este viaje.
        var meta = p.meta;
        ejecuta(p.f, function (real) { return meta <= 0 ? 0 : normaliza(meta + (real - base), d); }, false);
      } else if (p) {
        formasDe(d.vid).forEach(pintaForm);
      }
    }
    // SIEMPRE se lee el carrito justo antes (18-oct): se manda una cantidad ABSOLUTA y el carrito pudo cambiar en otra
    // pestaña o en la página del producto sin aviso; con lo guardado en memoria se pisaría.
    leeCarrito().then(function (fresco) {
      n = cuantasEn(fresco, d.vid);
      var x = calc(n);
      nueva = x === null ? n : x;
      // Nada que mandar (p. ej. «−» y otra pestaña ya lo quitó, o «+» pasaría el tope): se pinta lo que hay.
      if (x === null || nueva === n || (n === 0 && nueva <= 0)) return { soloVer: fresco };
      if (n === 0) return agregar(d.vid, nueva);
      return cambiar(d.vid, nueva, fresco);
    }).then(function (cart) {
      delete vuelo[d.vid];
      if (cart && cart.soloVer) {
        var cambio = firma(cart.soloVer) !== firma(estado);
        if (!cambio) { formasDe(d.vid).forEach(pintaForm); fin(true); return; }
        // El carrito cambió por fuera: también el cajón y la burbuja.
        return traeSecciones().catch(function () { return null; }).then(function (sec) {
          pintaSecciones(sec); aplicar(cart.soloVer, 'vuelta', null, true); fin(true);
        });
      }
      var subia = nueva > n;
      aplicar(cart, 'alco-carrito', d.vid);
      var quedo = cuantas(d.vid);
      if (subia && quedo < nueva) {
        // Sin existencia: los toques en cola se descartan y se muestra lo real.
        delete pendientes[d.vid];
        formasDe(d.vid).forEach(pintaForm);
        error(f, quedo > 0 ? 'Ya no hay más existencia: tu carrito quedó con ' + quedo + ' pz.' : 'No hay existencia suficiente para agregarlo.');
        fin(false);
        return;
      }
      fin(true);
    }).catch(function (e) {
      // Tras un error (p. ej. 422 por existencia, que a veces SÍ agrega lo disponible) se relee el carrito real y se
      // aplica como cambio propio: tarjeta, barra, cajón (sin abrirlo), burbuja, cartUpdate y alco:carrito.
      // Los toques en cola se descartan.
      delete vuelo[d.vid];
      delete pendientes[d.vid];
      var msg = e && e.deShopify ? e.message : 'No se pudo actualizar el carrito. Revisa tu conexión e intenta de nuevo.';
      return Promise.all([leeCarrito(), traeSecciones().catch(function () { return null; })]).then(function (r) {
        pintaSecciones(r[1]);
        aplicar(r[0], 'alco-carrito', d.vid, true);
        var quedo = cuantas(d.vid);
        if (nueva > n && quedo > n && quedo < nueva) msg = 'Ya no hay más existencia: tu carrito quedó con ' + quedo + ' pz.';
        error(f, msg);
      }).catch(function () {
        if (estado) formasDe(d.vid).forEach(pintaForm);
        error(f, msg);
        sucio = true; // se relee al terminar
      }).then(function () { fin(false); });
    });
  }

  // Sin JavaScript la forma manda a /cart/add normal; con JavaScript se queda en la página.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('[data-acx-cmp]')) return;
    e.preventDefault();
    e.stopPropagation();
    if (Number(f.dataset.recienAgregar || 0) > Date.now()) return; // toque que iba a «−» y cayó en «Agregar»
    accion(f, 1);
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-cmp-q]') : null;
    if (!b) return;
    var f = b.closest('[data-acx-cmp]');
    if (!f || b.disabled) return;
    e.preventDefault();
    accion(f, Number(b.getAttribute('data-cmp-q')) > 0 ? 1 : -1);
  });

  /* ---------- Barra flotante de envío gratis ---------- */
  var barra = null, ultimoTxt = '';
  function enVistaPrevia() { return !!document.getElementById('PBarNextFrameWrapper'); }
  function mideBarra() {
    if (!barra) return;
    var r = barra.hidden ? null : barra.getBoundingClientRect();
    var alto = r && r.height ? Math.ceil(window.innerHeight - r.top) : 0;
    document.documentElement.style.setProperty('--alco-bf-alto', alto + 'px');
  }
  function pintaBarra() {
    if (!barra) return;
    barra.classList.toggle('alco-bf--alta', enVistaPrevia());
    if (!estado || META === null) { mideBarra(); return; }
    var tot = Number(estado.total_price) || 0;
    var visible = Number(estado.item_count) > 0;
    barra.hidden = !visible;
    var falta = META - tot, listo = falta <= 0;
    var pct = listo ? 100 : Math.max(0, Math.min(100, Math.floor(tot * 100 / META)));
    barra.classList.toggle('is-listo', listo);
    var txt = barra.querySelector('[data-bf-txt]');
    var clave = listo ? 'listo' : 'falta:' + falta;
    if (txt && clave !== ultimoTxt) {
      ultimoTxt = clave;
      txt.textContent = '';
      if (listo) {
        var b0 = document.createElement('b'); b0.textContent = '¡Ya tienes envío GRATIS!'; txt.appendChild(b0);
      } else {
        txt.appendChild(document.createTextNode('Te faltan '));
        var b1 = document.createElement('b'); b1.textContent = dinero(falta); txt.appendChild(b1);
        txt.appendChild(document.createTextNode(' para envío gratis'));
      }
    }
    var pista = barra.querySelector('[data-bf-pista]');
    if (pista) {
      pista.setAttribute('aria-valuenow', pct);
      var sp = pista.querySelector('span'); if (sp) sp.style.width = pct + '%';
    }
    var t = barra.querySelector('[data-bf-total]');
    if (t) t.textContent = dinero(tot);
    mideBarra();
  }
  /* Foco al cerrar el cajón abierto desde «Ver carrito» (18-oct, revisor): el close() del tema enfoca el enlace ANTES de
     quitar body.overflow-hidden, y con esa clase la barra está oculta, así que el foco se iba al <body>. Cuando la clase se
     quita y el foco quedó en el cajón o en el body, se regresa al enlace (o a la burbuja si la barra ya no se ve). */
  function devuelveFoco() {
    if (!window.MutationObserver) return;
    var conClase = document.body.classList.contains('overflow-hidden');
    new MutationObserver(function () {
      var ahora = document.body.classList.contains('overflow-hidden');
      var seQuito = conClase && !ahora;
      conClase = ahora;
      if (!seQuito || !barra) return;
      var cd = document.querySelector('cart-drawer');
      var a = barra.querySelector('[data-bf-ver]');
      if (!cd || !a || cd.activeElement !== a || cd.classList.contains('active')) return;
      var act = document.activeElement;
      if (act && act !== document.body && act !== document.documentElement && !cd.contains(act)) return;
      if (!barra.hidden && a.getClientRects().length) a.focus({ preventScroll: true });
      if (document.activeElement !== a) {
        var b = document.getElementById('cart-icon-bubble');
        if (b) b.focus({ preventScroll: true });
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  function iniciaBarra() {
    barra = document.querySelector('[data-alco-bf]');
    if (!barra) return;
    // Al cargar, la clave del texto es la que pintó Liquid (data-bf-clave, 18-oct): si no cambió, el texto aria-live no
    // se reescribe y el lector de pantalla no lo vuelve a anunciar en cada página.
    var t0 = barra.querySelector('[data-bf-txt]');
    ultimoTxt = (t0 && t0.getAttribute('data-bf-clave')) || (barra.classList.contains('is-listo') ? 'listo' : '');
    var ver = barra.querySelector('[data-bf-ver]');
    if (ver && document.querySelector('cart-drawer')) ver.setAttribute('aria-haspopup', 'dialog');
    barra.addEventListener('click', function (e) {
      var a = e.target.closest('[data-bf-ver]');
      if (!a) return;
      var cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.open === 'function') { e.preventDefault(); cd.open(a); }
    });
    devuelveFoco();
    if (window.ResizeObserver) new ResizeObserver(mideBarra).observe(barra);
    window.addEventListener('resize', mideBarra, { passive: true });
    pintaBarra();
    // La barra negra de la vista previa de Shopify llega después.
    setTimeout(pintaBarra, 1500);
    setTimeout(pintaBarra, 4000);
  }

  /* ---------- Cambios del carrito que vienen de otro lado ---------- */
  function escuchaTema() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
          if (!ev || ev.source === 'alco-carrito') return;
          var c = ev.cartData;
          // cart.js (cajón / página del carrito) manda el carrito completo; product-form manda sólo la línea agregada.
          if (c && Array.isArray(c.items) && typeof c.total_price === 'number' && typeof c.item_count === 'number') {
            aplicar(c, 'tema');
            if (enVuelo) sucio = true; // un cambio propio en curso podría contestar con un carrito más viejo
          } else programa();
        });
      }
    } catch (e) { /* sin pubsub */ }
    // Cualquier repintado del cajón (product-form, «Agregar todo» de la Lista de resurtidos…).
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(function () {
        var C = customElements.get('cart-drawer');
        if (!C || C.prototype.__alcoCarrito || typeof C.prototype.renderContents !== 'function') return;
        var orig = C.prototype.renderContents;
        C.prototype.renderContents = function () { var r = orig.apply(this, arguments); programa(); return r; };
        C.prototype.__alcoCarrito = true;
      });
    }
    // Al volver a la pestaña (o del bfcache) el carrito pudo cambiar en otra: se relee (18-oct).
    window.addEventListener('pageshow', function (e) { if (e.persisted) programa('vuelta'); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') programa('vuelta'); });
    window.addEventListener('focus', function () { programa('vuelta'); });
  }

  function inicia() {
    iniciaBarra();
    escuchaTema();
    if (document.querySelector('[data-acx-cmp]') || barra) {
      var g0 = gen;
      leeCarrito().then(function (c) { if (!enVuelo && g0 === gen) aplicar(c, 'inicio'); }).catch(function () { /* se queda lo que pintó Liquid */ });
    }
    // Tarjetas que llegan después (filtros, scroll infinito, recomendaciones).
    if (window.MutationObserver) {
      var pend = false;
      new MutationObserver(function (muts) {
        if (pend || !estado) return;
        for (var i = 0; i < muts.length; i++) {
          var ns = muts[i].addedNodes;
          for (var j = 0; j < ns.length; j++) {
            var n = ns[j];
            if (n.nodeType === 1 && (n.matches('[data-acx-cmp]') || n.querySelector('[data-acx-cmp]'))) {
              pend = true;
              setTimeout(function () { pend = false; document.querySelectorAll('[data-acx-cmp]').forEach(pintaForm); }, 60);
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.alcoCarrito = { leer: function () { return estado; }, refrescar: function () { programa(); }, dinero: dinero };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
})();
